import { useState } from 'react';

import type { CreatePetitionUpdateResponse, CreatePetitionUpdateResult, PetitionUpdateError } from '../../types';

import { useGenCreateCallback } from './useGenCreateCallback';

export function useCreatePetitionUpdate(): CreatePetitionUpdateResult {
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<PetitionUpdateError | undefined>(undefined);
	const [success, setSuccess] = useState<CreatePetitionUpdateResponse | undefined>(undefined);

	const startLoading = () => {
		setSuccess(undefined);
		setError(undefined);
		setLoading(true);
	};
	const finishSuccesfully = (response: CreatePetitionUpdateResponse) => {
		setSuccess(response);
		setLoading(false);
	};
	const finishWithError = (submitError?: PetitionUpdateError) => {
		setError(submitError);
		setLoading(false);
	};

	const create = useGenCreateCallback({ startLoading, finishSuccesfully, finishWithError });
	return [create, { success, error, loading }];
}
